"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _MinorVersionDropdownMenu = _interopRequireDefault(require("./MinorVersionDropdownMenu"));
var _events = require("../../analytics/events");
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  return {
    assetMinorVersions: _assets.selectors.assetMinorVersions(state, asset) || []
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var push = _ref2.router.push,
    trackEvent = _ref2.trackEvent;
  return {
    onMinorVersionChange: function () {
      var _onMinorVersionChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref3) {
        var asset, status, assetMinorVersions, selectedMinor, path;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              asset = _ref3.asset, status = _ref3.status, assetMinorVersions = _ref3.assetMinorVersions, selectedMinor = _ref3.selectedMinor, path = _ref3.path;
              trackEvent(_events.EVENT_TYPES.VERSION_DROPDOWN_CLICKED, {
                organizationId: asset.organization.id,
                groupId: asset.groupId,
                assetId: asset.assetId,
                type: asset.type,
                minorVersion: asset.minorVersion,
                minorVersionPosition: assetMinorVersions.map(function (minor) {
                  return minor.minorVersion;
                }).indexOf(selectedMinor),
                minorVersionCount: assetMinorVersions.length,
                originalFormat: asset.originalFormat,
                originalFormatVersion: asset.originalFormatVersion,
                status: status
              });
              _context.next = 4;
              return dispatch(_portals.actions.pageLoading());
            case 4:
              push(path);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onMinorVersionChange(_x) {
        return _onMinorVersionChange.apply(this, arguments);
      }
      return onMinorVersionChange;
    }()
  };
};
var ConnectedMinorVersionDropdownMenu = (0, _redux.compose)(_exchangeReactHooks.withRouter, _exchangeReactHooks.withAnalytics, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_MinorVersionDropdownMenu.default);
var _default = exports.default = ConnectedMinorVersionDropdownMenu;
//# sourceMappingURL=MinorVersionDropdownMenu.container.js.map